import React, { useCallback } from 'react';

import { Checkbox } from '@makemydeal/dr-ui-bricks-components';
import type { DealType } from '@makemydeal/dr-shared-bff-types';
import CheckboxOptionGroup from '../common/CheckboxOptionGroup/CheckboxOptionGroup';
import { PaymentOptionsSectionContainer, SectionQuestion } from './PaymentOptionsSection.styles';
import { DEAL_TYPE_LABELS, DEAL_TYPES } from '../../constants';
import type { PaymentOptionsSectionProps } from '../../types';

const PaymentOptionsSection: React.FC<PaymentOptionsSectionProps> = ({ selectedDealTypes, onToggle }) => {
    const handleCheckboxChange = useCallback(
        (dealType: DealType) => (e: React.ChangeEvent<HTMLInputElement>) => {
            const newSelected = new Set(selectedDealTypes);
            if (e.target.checked) {
                newSelected.add(dealType);
            } else {
                newSelected.delete(dealType);
            }
            onToggle(Array.from(newSelected));
        },
        [selectedDealTypes, onToggle]
    );

    return (
        <PaymentOptionsSectionContainer>
            <SectionQuestion size="large" weight="bold">
                Which payment options would you like to explore?
            </SectionQuestion>
            <CheckboxOptionGroup aria-label="Payment Options" data-testid="payment-options-group">
                {DEAL_TYPES.map((dealType) => (
                    <Checkbox
                        key={dealType}
                        label={DEAL_TYPE_LABELS[dealType]}
                        checked={selectedDealTypes.includes(dealType)}
                        onChange={handleCheckboxChange(dealType)}
                        name={`payment-option-${dealType}`}
                        data-testid={`payment-option-${dealType}`}
                    />
                ))}
            </CheckboxOptionGroup>
        </PaymentOptionsSectionContainer>
    );
};

export default PaymentOptionsSection;
